<div class="dialog-message">
  <div class="dialog-message__close" *ngIf="!dialogRef.disableClose">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="dialog-message__root" mat-dialog-content>
    <div class="dialog-message__image" *ngIf="data.image">
      <img [src]="data.image" alt="" />
    </div>

    <div class="dialog-message__message">
      <h6 class="mat-headline-6">{{ data.message.title }}</h6>
      <p class="" [innerHTML]="data.message.content"></p>
    </div>
  </div>
  <div class="dialog-message__actions" mat-dialog-actions>
    <button
      mat-flat-button
      color="primary"
      *ngIf="data.actions.primaryAction"
      fzOpenZenDesk
    >
      {{ data.actions.primaryAction.label }}
    </button>
  </div>
</div>
